export class LojistikFaturaDetay {

    id: number;
    lojistikFaturaId: number;
    irsaliyeNo: number;
    cariKodu: number;

    constructor(obj?: any) {
        if (obj == null) {
            return;
        }
        Object.assign(this, obj);
    }
}
